"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    data: _propTypes.default.shape({
      rating: _propTypes.default.string,
      message: _propTypes.default.string,
      reviewCount: _propTypes.default.string,
      maxRate: _propTypes.default.string
    }).isRequired,
    backgroundColor: _propTypes.default.string,
    messageColor: _propTypes.default.string,
    reviewCountColor: _propTypes.default.string,
    scoreCardLeftColor: _propTypes.default.string,
    scoreCardRightColor: _propTypes.default.string,
    fontSize: _propTypes.default.string,
    lineHeight: _propTypes.default.string,
    oneline: _propTypes.default.bool,
    textType: _propTypes.default.string,
    reviewTranslation: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    oneline: false,
    backgroundColor: _constant2.DEFAULT_STYLES.DEFAULT_BACKGROUND,
    messageColor: _constant2.DEFAULT_STYLES.DEFAULT_MESSAGE_COLOR,
    reviewCountColor: _constant2.DEFAULT_STYLES.DEFAULT_REVIEW_COUNT_COLOR,
    scoreCardLeftColor: _constant2.DEFAULT_STYLES.DEFAULT_SCORE_CARD_LEFT_COLOR,
    scoreCardRightColor: _constant2.DEFAULT_STYLES.DEFAULT_SCORE_CARD_RIGHT_COLOR,
    fontSize: _constant2.DEFAULT_STYLES.DEFAULT_FONT_SIZE,
    lineHeight: _constant2.DEFAULT_STYLES.DEFAULT_LINE_HEIGHT,
    textType: 'default'
  }
};
exports.default = _default;